import "../global_function";
import "../global_constant";
import App from "./App.vue";
import VueCookies from "vue-cookies";
import router from "./router/index.js";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

// css
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/main.sass";

const tokenExpiredTime = config.token_expire || "3d";
VueCookies.config(tokenExpiredTime);

Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });
Vue.use(VueCookies);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
